import { useEffect, useState } from "react"

import queryString from "query-string"

const getResizedAvatarUrl = (url: string, size: number, dpr: number = 1) => {
  const parsedUrl = queryString.parseUrl(url)
  parsedUrl.query.s = (size * dpr).toString(10)

  return queryString.stringifyUrl(parsedUrl)
}

export const useResizedAvatarUrl = (url: string, size: number) => {
  const initialResizedAvatarUrl = getResizedAvatarUrl(url, size)

  const [resizedAvatarUrl, setResizedAvatarUrl] = useState(
    initialResizedAvatarUrl
  )

  useEffect(() => {
    if (typeof window !== "undefined") {
      setResizedAvatarUrl(
        getResizedAvatarUrl(url, size, window.devicePixelRatio)
      )
    }
  }, [size, url])

  return resizedAvatarUrl
}
